import { ArrowLeftIcon } from "./ArrowLeftIcon";
import { ArrowShareIcon } from "./ArrowShareIcon";
import { ArthaLink20x17Icon } from "./ArthaLink20x17Icon";
import { ArthaLinkIcon } from "./ArthaLinkIcon";
import { ArthaLinkSmIcon } from "./arthalinkSmIcon";
import { BinIcon } from "./binIcon";
import { ClockIcon } from "./ClockIcon";
import { CopyIcon } from "./copyIcon";
import { EditBrushIcon } from "./editBrushIcon";
import { FrameIcon } from "./FrameIcon";
import { LocationSmIcon } from "./locationSmIcon";
import { MenuIcon } from "./menuIcon";
import { NotificationIcon } from "./notificationIcon";
import { OfficeBagIcon } from "./OfficeBagIcon";
import { RoundCheckIcon } from "./roundCheckIcon";
import { ShareIcon } from "./shareIcon";
import { WebsiteIcon } from "./WebsiteIcon";
import { SearchIcon } from "./SearchIcon";
import { FilterIcon } from "./FilterIcon";
import { RainbowIcon } from "./RainbowIcon";
import { Filter2Icon } from "./Filter2Icon";
import { ShareIcon2 } from "./ShareIcon2";
import { EyeIcon } from "./EyeIcon";

export const ICONS = {
  ARROW_LEFT: ArrowLeftIcon,
  ARROW_SHARE: ArrowShareIcon,
  ARTHA_LINK: ArthaLinkIcon,
  ARTHA_LINK_BADGE: ArthaLink20x17Icon,
  ARTHA_LINK_SMALL: ArthaLinkSmIcon,
  BIN: BinIcon,
  CLOCK: ClockIcon,
  COPY: CopyIcon,
  EDIT_BRUSH: EditBrushIcon,
  FRAME: FrameIcon,
  LOCATION_PIN: LocationSmIcon,
  MENU: MenuIcon,
  NOTIFICATION: NotificationIcon,
  OFFICE_BAG: OfficeBagIcon,
  ROUND_CHECK: RoundCheckIcon,
  SHARE: ShareIcon,
  WEBSITE: WebsiteIcon,
  SEARCH: SearchIcon,
  FILTER: FilterIcon,
  FILTER2: Filter2Icon,
  RAINBOW: RainbowIcon,
  SHAREICON2: ShareIcon2,
  EYEICON: EyeIcon,
};

export {
  ArrowLeftIcon,
  ArrowShareIcon,
  ArthaLink20x17Icon,
  ArthaLinkIcon,
  ArthaLinkSmIcon,
  BinIcon,
  ClockIcon,
  CopyIcon,
  EditBrushIcon,
  FrameIcon,
  LocationSmIcon,
  MenuIcon,
  NotificationIcon,
  OfficeBagIcon,
  RoundCheckIcon,
  ShareIcon,
  WebsiteIcon,
  SearchIcon,
  FilterIcon,
  Filter2Icon,
  RainbowIcon,
};
